import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./coursesTour.css";

export function startCourseFormTour() {
  const steps = [
    {
      popover: {
        title: "Hướng dẫn nhanh",
        description:
          "Tour giúp bạn đi qua các vùng quan trọng trong form tạo/cập nhật khóa học.",
        side: "over",
        align: "center",
      },
    },
  ];

  const segments = [
    {
      selector: '[data-tour="course-form-header"]',
      title: "Header form",
      description:
        "Xác định bạn đang thêm mới hay chỉnh sửa khóa học.",
      side: "bottom",
    },
    {
      selector: '[data-tour="course-form-basic"]',
      title: "Thông tin cơ bản",
      description:
        "Nhập mã (khi sửa) và tên khóa học.",
      side: "right",
    },
    {
      selector: '[data-tour="course-form-classify"]',
      title: "Phân loại & cấp độ",
      description:
        "Chọn môn học, nơi dạy và trình độ phù hợp.",
      side: "right",
    },
    {
      selector: '[data-tour="course-form-content"]',
      title: "Nội dung & thời lượng",
      description:
        "Nhập thời lượng, thứ tự hiển thị và mô tả khóa học.",
      side: "left",
    },
    {
      selector: '[data-tour="course-form-actions"]',
      title: "Hành động lưu",
      description:
        "Bấm Hoàn tất & Lưu / Cập nhật để kết thúc.",
      side: "top",
    },
  ];

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (!el) continue;
    steps.push({
      element: el,
      popover: {
        title: seg.title,
        description: seg.description,
        side: seg.side,
      },
    });
  }

  if (steps.length <= 1) {
    window.alert("Không tìm thấy vùng để chạy hướng dẫn. Hãy mở form rồi thử lại.");
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    stagePadding: 10,
    stageRadius: 14,
    overlayOpacity: 0.68,
    overlayColor: "#0f172a",
    popoverClass: "courses-tour-popover",
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    steps,
  });

  d.drive();
}
